import { render, staticRenderFns } from "./Recipes.vue?vue&type=template&id=282c9d78&scoped=true"
import script from "./Recipes.vue?vue&type=script&lang=ts"
export * from "./Recipes.vue?vue&type=script&lang=ts"
import style0 from "./Recipes.vue?vue&type=style&index=0&id=282c9d78&prod&scoped=true&lang=css"
import style1 from "./Recipes.vue?vue&type=style&index=1&id=282c9d78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282c9d78",
  null
  
)

export default component.exports